import React, { useState, useEffect } from 'react';
import { Link, useRouteMatch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { find } from 'lodash';
import { fetchProductByHandle, toggleCart, addToCart } from '../../actions';
import { getPrettyPrice, truncateText } from '../../helpers';
import classNames from 'classnames';

const ProductDescription = ({visible, product, onClose}) => {
  if(!product){
    return false;
  }
  return (
    <div className={classNames('description', {
      'description--visible': visible
      })}>
      <div>
        <h5>Description</h5>
        <br />
        <span dangerouslySetInnerHTML={{__html:product.descriptionHtml}} />
      </div>
    </div>
  )
}

const ProductFullscreen = ({visible, product, onClose, showDescription}) => {
  const [ visibleImage, setVisibleImage ] = useState(0);
  const [ descriptionVisible, setDescriptionVisible ] = useState(false);

  useEffect(() => {
    if(visible){
      document.body.classList.add('header-hidden');
    }else{
      document.body.classList.remove('header-hidden');
    }
  }, [visible]);

  useEffect(() => {
    setDescriptionVisible(showDescription)
  }, [showDescription]);

  const handleImageClick = () => {
    if(visibleImage + 1 == product.images.length){
      setVisibleImage(0);
    }else{
      setVisibleImage(visibleImage + 1);
    }
  }

  const handleDescriptionToggle = () => {
    setDescriptionVisible(current => !current);
  }

  if(!product){
    return false;
  }

  return (
    <div className={classNames('product-fullscreen', {
      'product-fullscreen--visible': visible
      })}>
      <div className="product-fullscreen__header">
        <div>{product.title}</div>
        <div className="index">
          <div className="index__current">
            {(visibleImage + 1).toString().padStart(2, 0)}
          </div>
          <div className="index__total">
            {product.images.length.toString().padStart(2, 0)}
          </div>
        </div>
      </div>
      <div className="product-fullscreen__body">
        {product && product.images &&
          <div className={classNames('images', {
            'images--visible': !descriptionVisible
            })}>
            {product.images.map((image, i) =>
                <img
                  key={image.id}
                  className={classNames('image', {
                    'image--active': visibleImage == i
                  })}
                  onClick={() => handleImageClick()}
                  src={image.src}
                />
            )}
          </div>
        }
        <ProductDescription visible={descriptionVisible} product={product}/>
      </div>
      <div className="product-fullscreen__footer">
        <div className="a" onClick={e => onClose(e)}>Close</div>
        <div className="a" onClick={e => handleDescriptionToggle(e)}>
          {descriptionVisible ?
            <span>Images</span>
            :
            <span>Description</span>
          }
        </div>
      </div>
    </div>
  )
}
const ShowProduct = ({product, loading, fetchProductByHandle, addToCart, toggleCart}) => {
  const [ visibleImage, setVisibleImage ] = useState(0);
  const [ fullscreen, setFullscreen ] = useState(false);
  const [ showFullscreenDescription, setShowFullscreenDescription ] = useState(false);
  const [ selectedVariant, setSelectedVariant ] = useState(false);
  const [ addedToCart, setAddedToCart ] = useState(false);
  const [ priceOnRequest, setPriceOnRequest ] = useState(false);

  const match = useRouteMatch();

  useEffect(() => {
    document.body.classList.add('dark');

    return function cleanup(){
      document.body.classList.remove('dark');
    }
  }, []);

  useEffect(() => {
    if(!product && !loading){
      fetchProductByHandle(match.params.handle);
    }
  }, [match.params.handle]);


  const handleImageClick = () => {
    if(visibleImage + 1 == product.images.length){
      setVisibleImage(0);
    }else{
      setVisibleImage(visibleImage + 1);
    }
  }

  const _handleVariantSelect = e => {
    const variant = product.variants[e.target.value]

    setSelectedVariant(variant);
    setPriceOnRequest(variant.price === '0.00');

    if(addedToCart){
      setAddedToCart(false);
    }
  }

  const _handleAddToCart = () => {
    addToCart({
      productId: selectedVariant.product_id,
      variantId: selectedVariant.id,
      price: selectedVariant.price,
      productTitle: product.title,
      variantTitle: selectedVariant.title,
    });
    setAddedToCart(true);
    setSelectedVariant(false);
  }

  const handleSetFullscreen = (type, goToDescription = false) => {
    if(goToDescription){
      setShowFullscreenDescription(true);
    }

    setFullscreen(type);
  }

  const truncatedDescription = product && product.descriptionHtml ? truncateText(product.descriptionHtml, 400) : false;

  return (
    <div className="show-product transition">
      <div className="show-product__images">
        {product && product.images &&
          <React.Fragment>
            {product.images.map((image, i) =>
                <img
                  key={image.id}
                  className={classNames('show-product__image', {
                  'show-product__image--active': visibleImage == i
                  })}
                  onClick={() => handleImageClick()}
                  src={image.src}
                />
            )}
            <div className="index">
              <div className="index__current">
                {visibleImage + 1}
              </div>
              <div className="index__total">
                {product.images.length}
              </div>
            </div>
          </React.Fragment>
        }
        <div className="fullscreen-toggle" onClick={e => handleSetFullscreen(true)}>
          [&nbsp;&nbsp;&nbsp;]
          <span>Fullscreen</span>
        </div>
      </div>
      <div className="show-product__content">
        {product &&
          <React.Fragment>
            <div className="show-product__product-type">
              {product.productType}
            </div>
            <div className="show-product__title">
              {product.title}
            </div>
            {product.descriptionHtml &&
              <React.Fragment>
                <div className="show-product__description" dangerouslySetInnerHTML={{__html: truncatedDescription}} />
                {truncatedDescription !== product.descriptionHtml && (
                  <div className="show-product__description__read-more" onClick={e => handleSetFullscreen(true, true)}>
                    Details
                  </div>
                )}
              </React.Fragment>
            }
            <div className={classNames('show-product__actions', {'selected': selectedVariant})}>
              {product.variants &&
                <div className="show-product__variants">
                  <div className={classNames('field field--select', {'selected': selectedVariant})}>
                    <select onChange={e => _handleVariantSelect(e)} defaultValue="">
                      <option value="" disabled>Option</option>
                      {product.variants.map((variant, i) => (
                        <option key={i} value={i} disabled={!variant.available}>
                          {variant.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              }
              {selectedVariant &&
                <div className="show-product__price">
                  {getPrettyPrice(selectedVariant.price)}
                </div>
              }
            </div>
            <div className="show-product__buy" disabled={!selectedVariant && !addedToCart}>
              {addedToCart ?
                <React.Fragment>
                  <span className="dark-blue">
                    Thank you!
                  </span>
                  <span className="a" onClick={() => toggleCart()}>
                    View Cart
                  </span>
                </React.Fragment>
                :
                (priceOnRequest ?
                  <a href="mailto:shop@akkurat.tv" className="a">
                    Inquire Now
                  </a>
                  :
                  <span className="a" onClick={() => _handleAddToCart()}>
                    Add to Cart
                  </span>
                )
              }
            </div>
          </React.Fragment>
        }
        <div className="show-product__footer-link">
          <Link to="/shop/faq">FAQ</Link>
        </div>
      </div>
      <ProductFullscreen
        visible={fullscreen}
        showDescription={showFullscreenDescription}
        onClose={() => {
          setFullscreen(false);
          setTimeout(() => {
            setShowFullscreenDescription(false);
          }, 1000);
        }}
        product={product} />
    </div>
  )
}




const mapStateToProps = (state, ownProps) => {
  const product = find(state.products.products, {handle: ownProps.handle});

  return {
    product,
    loading: state.products.loading
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchProductByHandle: handle => {
      dispatch(fetchProductByHandle(handle));
    },
    addToCart: product => {
      dispatch(addToCart(product));
    },
    toggleCart: () => {
      dispatch(toggleCart());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowProduct);
